import { TextInput } from "@milestone/component-library";
import React from "react";
import { Formik } from "formik";
import {
  BlueButton,
  Container,
  OutlineButton,
  SaveButtonContainer,
  StyledForm,
} from "../../pages/Admin/Admin.styles";
import { Header, Section } from "./addMember.styles";
import { useHistory } from "react-router-dom";
import search from "../../assets/Table/Search.svg";
import { AddMembersSchema, AddMembersType } from "./addMember";
import { selectMemberMap } from "../../store/hooks";
import styled from "styled-components";

const ABlueButton = styled(BlueButton)`
  height: 47px;
`;
const AOutlineButton = styled(OutlineButton)`
  height: 47px;
`;

interface TeamFormProps {
  header: string;
  submitValues: (values: AddMembersType) => void;
  handleCancel: () => void;
  value?: AddMembersType;
}

const defaultValue: AddMembersType = {
  members: [],
};

export const AddMember: React.FC<TeamFormProps> = ({
  header,
  submitValues,
  value = defaultValue,
}) => {
  const history = useHistory();

  const handleCancel = () => {
    const currentLocation = history.location;
    currentLocation.pathname =
      currentLocation.pathname.split("/").slice(0, -1).join("/") + "/edit";
    history.push(currentLocation);
  };

  const members = selectMemberMap();

  const SaveButtons = (
    <SaveButtonContainer>
      <ABlueButton type="submit">Add Members</ABlueButton>
      <AOutlineButton type="button" onClick={handleCancel}>
        Cancel
      </AOutlineButton>
    </SaveButtonContainer>
  );

  return (
    <Container>
      {!!members.size && (
        <Formik
          initialValues={value}
          validationSchema={AddMembersSchema}
          onSubmit={submitValues}
        >
          {() => (
            <StyledForm>
              <Header>{header}</Header>

              <Section>
                <TextInput
                  name="members"
                  placeholder="Search Members"
                  icon={search}
                  multiple
                  options={[...members.keys()]}
                />
                {SaveButtons}
              </Section>
              {/*errors && <div>{JSON.stringify(errors)}</div>*/}
            </StyledForm>
          )}
        </Formik>
      )}
    </Container>
  );
};
